module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13icglt/tc-custom/9781647000219.jpg?1708752099086",
      "alt": "This image is the cover for the book Seasonal Slow Knitting"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Seasonal Slow Knitting\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Thiessen’s new book is all about promoting creativity at a slower pace, offering advice on finding the time and space to knit in a restful, calming way.” —"), _c('i', [_vm._v("The Knitter")])]), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Slow Knitting ")]), _vm._v("introduced crafters to a process of more mindful making through five basic tenets: source carefully, make thoughtfully, think seasonally, experiment fearlessly, and explore openly. Now, this seasonal approach encourages knitters to delve deeper into those concepts, applying them to everyday making through a series of essays, projects, and patterns that explore the life of a knitter throughout the year. Organized similarly to a seasonal planting guide or farmer’s almanac, each chapter and section is designed to identify and encourage small ways that knitters may begin to employ noticeable change: organizing your yarn stash, carving out time for knitting, and starting on that baby blanket in a timely manner. The ideas explored here add up to a fuller, more mindful year, all through the joyful experience that is knitting. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hannah Thiessen, Katie Starks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Hannah Thiessen is an experienced knitter, knitwear designer, teacher, and author of Slow Knitting. She lives in Nashville.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0